import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { faWandMagicSparkles, faSpinner, faPlus, faCode, faTimes, faEraser } from '@fortawesome/free-solid-svg-icons';
import { ProcessingsService, AssistSuggestion } from '../../services/processings.service';
import { AlertService } from '../alert-service/alert-service';

@Component({
  selector: 'app-processing-assistant',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './processing-assistant.component.html',
  styleUrls: ['./processing-assistant.component.scss'],
})
export class ProcessingAssistantComponent {
  icons = { faWandMagicSparkles, faSpinner, faPlus, faCode, faTimes, faEraser };

  @Input() show = false;
  @Input() sample: any = null;
  @Input() delfosServerConfigId: string | null | undefined = null;
  @Input() llmModel: string | null | undefined = null;
  @Output() addSuggestion = new EventEmitter<AssistSuggestion>();
  @Output() close = new EventEmitter<void>();

  text = '';
  loading = false;
  suggestions: AssistSuggestion[] = [];

  constructor(
    private service: ProcessingsService,
    private alert: AlertService,
    private translate: TranslateService,
  ) {}

  generate(): void {
    if (!this.text.trim() || this.loading) return;
    this.loading = true;
    this.suggestions = [];
    this.service.assist({
      text: this.text.trim(),
      sample: this.sample,
      delfos_server_config_id: this.delfosServerConfigId,
      llm_model: this.llmModel,
    }).subscribe({
      next: (suggestions) => {
        this.suggestions = suggestions || [];
        this.loading = false;
        if (!this.suggestions.length) {
          this.alert.showInfo(this.translate.instant('PROCESSINGS.ASSISTANT.NO_SUGGESTIONS'));
        }
      },
      error: () => {
        this.loading = false;
        this.alert.showError(this.translate.instant('PROCESSINGS.ASSISTANT.FAILED'));
      },
    });
  }

  add(suggestion: AssistSuggestion): void {
    this.addSuggestion.emit(suggestion);
  }

  clear(): void {
    this.text = '';
    this.suggestions = [];
  }

  onClose(): void {
    this.close.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
